import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Login from './Login';
import WriterDashboard from './WriterDashboard';
import HomePage from './HomePage';
import ArticlePage from "./ArticlePage";
import About from './About';
import Contact from './Contact';
import Register from './Register';
import api from './Api';
import ProtectedRoute from './ProtectedRoute';
import { useEffect } from 'react';
import Privacy from './Privacy';
import SearchPage from './SearchPage';


const trackVisitor = async () => {
  const screenResolution = `${window.screen.width}x${window.screen.height}`;
  const referrer = document.referrer || "Direct Visit";
  const pageUrl = window.location.href;
  const userAgent = navigator.userAgent.toLowerCase();

  let browser = "Unknown";
  if (userAgent.includes("chrome")) browser = "Chrome";
  else if (userAgent.includes("firefox")) browser = "Firefox";
  else if (userAgent.includes("safari")) browser = "Safari";
  else if (userAgent.includes("edge")) browser = "Edge";

  let os = "Unknown";
  if (userAgent.includes("win")) os = "Windows";
  else if (userAgent.includes("mac")) os = "MacOS";
  else if (userAgent.includes("linux")) os = "Linux";

  const device = /Mobi|Android/i.test(navigator.userAgent) ? "Mobile" : "Desktop";
  const visitorData = {
    screenResolution,
    referrer,
    pageUrl,
    browser,
    os,
    device,
  };
  // TODO: Uncomment the following line to send visitor data to the server
  try{
  await api.post("/visitors/track", visitorData);
  }catch(err){
    console.error("Error tracking visitor:", err);
  }
};

const App = () => {
  useEffect(() => {
    trackVisitor();
  }, []);
  return (
    <Router  basename="/">
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/about" element={<About />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/login" element={<Login />} />
        <Route path="/blog/:slug" element={<ArticlePage />} />
        <Route path="/register" element={<Register />} />
        <Route path="/search" element={<SearchPage />} />
        <Route path="/writerdash" element={<ProtectedRoute element={<WriterDashboard />} requiredRole={["ROLE_ADMIN", "ROLE_WRITER"]} />} />
  
      </Routes>
    </Router>
  );
};

export default App;
